/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { const_var, params } from '../../../../../../redux/reducers/reducer'
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { useDispatch, useSelector } from 'react-redux';
import { setWallCloseStateWrap } from '../../../../../../action';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const TrimModel = () => {
    const dispatch = useDispatch();

    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)
    
    const [wallCloseState, setWallCloseState] = useState(0);
    // const [CSGJTrimModelGeometry, setCSGJTrimModelGeometry] = useState(null);
    // const [CSGwainscotTrimModelGeometry, setCSGwainscotTrimModelGeometry] = useState(null);    

    // const wainscotColor = useMemo(() => {
    //     if ((const_var.activeTab === 'doorwindow' && const_var.focusedSection !== 'center' && const_var.focusedSection !== '') || (params.is_translusant)) {
    //         return 'white'
    //     } else {
    //         return params.p_w_c_c.replace("0x","#");
    //     }
    // }, [params.p_w_c_c, const_var.activeTab, const_var.focusedSection, params.is_translusant])
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c]) 

    const leftTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if((params.add_left_lean && params.leantoAlignmentLeft == 2 && !(params.p_f_w === 'Open') && !(params.p_b_c_b_l_f === 'Open')) || (params.add_left_lean && (params.leantoAlignmentLeft == 1 || params.leantoAlignmentLeft == 3) && params.p_d === params.lean_p_d && !(params.p_f_w === 'Open') && !(params.p_b_c_b_l_f === 'Open')) || (params.p_f_w === 'Open' && params.cB_addStorage_check_left && !params.singleSlope && params.p_b_c_b_l_f !== 'Open')){
            // alert('dfdf')
            if (wallCloseState > -1) {
                model.moveTo(-(params.p_d / 2 + 0.26), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + (params.p_r_s !== 1 && - 0.2));
                model.lineTo(-(params.p_d / 2 + 0.26), params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + (params.p_r_s !== 1 && - 0.2));
                model.closePath();
            } 
        } else {
            // alert('123456')
            if (wallCloseState > -1) {
                model.moveTo(-(params.p_d / 2 + 0.26), wallCloseState);
                model.lineTo(-(params.p_d / 2 + 0.26), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(-(params.p_d / 2 + 0.03), wallCloseState);
                model.closePath();
            } 
        }

        return model;
    
    }, [params.p_h, params.p_w, wallCloseState, params.p_d, params.p_r_s, params.p_r_p, params.singleSlope && params.freeStandingSide === "left", params.lean_p_h, params.b_l_t_r_p, params.add_left_lean, params.b_l_l_t_f, params.lean_p_w, params.leantoAlignmentLeft, params.p_d, params.lean_p_d, params.p_f_w, params.p_b_c_b_l_f, params.cB_addStorage_check_left])

    const rightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if((params.add_left_lean && params.leantoAlignmentLeft == 3 && !(params.p_b_w === 'Open') && !(params.p_b_c_b_l_b === 'Open'))  || (params.add_left_lean && params.leantoAlignmentLeft == 1 && params.p_d === params.lean_p_d && !(params.p_b_w === 'Open') && !(params.p_b_c_b_l_b === 'Open')) || (params.p_b_w === 'Open' && params.cB_addStorage_check_left && !params.singleSlope && params.p_b_c_b_l_f !== 'Open')){
            if (wallCloseState > -1) {
                model.moveTo((params.p_d / 2 + 0.26), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + (params.p_r_s !== 1 && - 0.2));
                model.lineTo((params.p_d / 2 + 0.26), params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), params.p_h + overHeight);
                model.lineTo((params.p_d / 2 + 0.03), params.lean_p_h + params.lean_p_w * params.b_l_t_r_p / 12 + (params.p_r_s !== 1 && - 0.2));
                model.closePath();
            } 
        } else {   
            if (wallCloseState > -1) {
                model.moveTo(params.p_d / 2 + 0.03, wallCloseState);
                model.lineTo(params.p_d / 2 + 0.03, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_d / 2 + 0.26, (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_d / 2 + 0.26, wallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_h, params.p_w, wallCloseState, params.p_d, params.p_r_s, params.p_r_p, params.singleSlope && params.freeStandingSide === "left", params.lean_p_h, params.b_l_t_r_p, params.add_left_lean, params.b_l_l_t_f, params.lean_p_w, params.leantoAlignmentLeft, params.p_d, params.lean_p_d, params.p_b_w, params.p_b_c_b_l_b, params.cB_addStorage_check_left])

    // const leftLeanFrontTrimModel = useMemo(() => {
    //     const model = new THREE.Shape();
    //     if(params.lean_p_d === params.p_d || params.leantoAlignmentLeft === 2){
    //         model.moveTo(-(params.p_d / 2 + 0.26), wallCloseStateWrap.LLFrontWallCloseState);
    //         model.lineTo(-(params.p_d / 2 + 0.26), params.p_h) 
    //         model.lineTo(-(params.p_d / 2 + 0.03), params.p_h)
    //         model.lineTo(-(params.p_d / 2 + 0.03), wallCloseStateWrap.LLFrontWallCloseState);
    //         model.closePath();
    //     }
    //     return model;
    
    // }, [params.p_h, params.p_d, wallCloseStateWrap.LLFrontWallCloseState, params.lean_p_d, params.leantoAlignmentLeft])

    // const leftLeanBackTrimModel = useMemo(() => {
    //     const model = new THREE.Shape();
    //     if(params.lean_p_d === params.p_d || params.leantoAlignmentLeft === 3){
    //     model.moveTo(params.p_d / 2 + 0.03, wallCloseStateWrap.LLBackWallCloseState);
    //     model.lineTo(params.p_d / 2 + 0.03, params.p_h) 
    //     model.lineTo(params.p_d / 2 + 0.26, params.p_h)
    //     model.lineTo(params.p_d / 2 + 0.26, wallCloseStateWrap.LLBackWallCloseState);
    //     model.closePath();
    //     }
    //     return model;
    
    // }, [params.p_h, params.p_d, wallCloseStateWrap.LLBackWallCloseState, params.lean_p_d, params.leantoAlignmentLeft])

    const backStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();
 
        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }
 
        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03,  (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2,  (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.2, 0);
            model.closePath();
        }
 
        return model;
   
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope && params.freeStandingSide === "left", wallCloseState, params.p_c_p_l])

    const backStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (params.p_u_c) {
            model.moveTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, 0);
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) - 0.03, (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05, (params.singleSlope && params.freeStandingSide === "left" && params.p_l_w === 'Open') ? params.p_h - ((params.p_r_p / 12) * params.p_w) : (params.p_l_w === 'Open' && !params.p_c_p_l) ? params.p_h : wallCloseState - overHeight
        );
            model.lineTo(params.p_d / 2 - parseInt(params.p_u_t) + 0.05, 0);
            model.closePath();
        }

        return model;
    
    }, [params.p_h, params.p_w, params.p_d, params.p_r_p, params.p_r_s, params.p_u_c, params.p_u_t, params.singleSlope && params.freeStandingSide === "left", wallCloseState, params.p_c_p_l]);

    const mainTrimModel = useMemo(() => {
        /**********************cutting hole using CSG************************/

        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.p_d - (params.p_u_c ? (parseInt(params.p_u_t) + 0.15) : 0) + 0.3)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.position.set(-params.p_d / 2 - 0.15, wallCloseState + 0.1, -(params.p_w / 2 - 0.0025));
        meshJTrimModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI);
        meshDelModel_Temp.position.set(0, 0, -(params.p_w / 2 - 0.5));
        meshDelModel_Temp.updateMatrixWorld();

        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        const JTrimModel_CSG = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(
            JTrimModel_CSG,
            new THREE.Matrix4()
        )

        /**********************cutting hole using CSG for Wainscot************************/

        const storageLength = (params.p_u_c && params.p_l_w !== "Close") ? params.p_d - parseInt(params.p_u_t) + 0.18 : 0
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings( params.p_d - storageLength + 0.35)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('left', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.position.set(-(params.p_d / 2 - storageLength) - 0.2 ,3, -(params.p_w / 2));
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.rotateY(Math.PI);
        meshWainscotDelModel_Temp.position.set(0, 0, -(params.p_w / 2 - 0.5));
        meshWainscotDelModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);

        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGwainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        // setCSGJTrimModelGeometry(CSGJTrimModel.geometry);
        // setCSGwainscotTrimModelGeometry(CSGwainscotTrimModel.geometry);

        return {
            jTrim: CSGJTrimModel.geometry,
            wTrim: CSGwainscotTrimModel.geometry
        }

        /****************************************************************/
    }, [params.p_d, params.p_w, params.p_u_c, params.p_u_t, params.p_l_w, const_var.newDoorsArray, wallCloseState]);

    useMemo(() => {
        var wallCloseValue = -1;
        var tempCutState = -1;
        let leanHeightValue = -1;
        let finalHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) : params.p_h

        if (params.p_l_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_l_w === "One_Fourth_Close") {
            wallCloseValue = (finalHeight * 3) / 4;
        } else if (params.p_l_w === "Half_Close") {
            wallCloseValue = finalHeight / 2;
        } else if (params.p_l_w === "Three_Fourth_Close") {
            wallCloseValue = finalHeight / 4;
        } else if (params.p_l_w === "Close") {
            wallCloseValue = 0;
        } else {
            wallCloseValue = finalHeight - (3 * params.p_l_w) - 0.2;
        }

        if (params.p_c_p_l) {
            if (params.p_l_w === 'Open') {
                tempCutState = finalHeight - 1.5;
            } else {
                tempCutState = wallCloseValue - 1.5;
            }
        } else {
            tempCutState = wallCloseValue;
        }

        if (params.add_left_lean) {
            let leanFinalHeight = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p)/12) * params.lean_p_w);

            if(params.add_left_lean && leanFinalHeight > 0 &&  (Math.abs(params.p_l_w) * 3) -leanFinalHeight < 3)
            {    
                let wH = leanFinalHeight+0.2;
                tempCutState = params.p_h - wH
                if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH
            } else {
                if(isNaN(params.p_l_w) == false){
                    let wH = (3 * params.p_l_w) - 0.2;
                    tempCutState = finalHeight - wH
                    if (params.singleSlope) tempCutState = params.p_h  - (Number(params.p_r_p)/12) * params.p_w- wH
                }   
            }

            if (params.p_c_p_l) {
                setWallCloseState(tempCutState - 1.5);
                dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': tempCutState - 1.5}))
            }else{
                setWallCloseState(tempCutState);
                dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': tempCutState}))
            }

        } else {
            /** cutting panel options isn't disabled when wall close state over limit */
            if (tempCutState > 0) {
                setWallCloseState(tempCutState);
                dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': tempCutState}))
            } else {
                if (params.p_l_w === 'Open') {
                    setWallCloseState(-1);
                    dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': -1}))
                } else {
                    setWallCloseState(0);
                    dispatch(setWallCloseStateWrap({'cbLeftWallCloseState': 0}))
                }
            }
        }

    
    }, [params.p_w, params.p_l_w, params.p_c_p_l, params.p_h, params.add_left_lean, params.lean_p_h, params.lean_p_w, params.b_l_t_r_p, params.singleSlope && params.freeStandingSide === "left"])

    const mainColor = useMemo(() => (params.p_t_c.replace("0x","#")), [params.p_t_c]) 

    return (
        <group name='trim-group' rotation={[0, Math.PI / 2, 0]}>
            <mesh name="left-left-trim" position={[0.03, 0, -(params.p_w / 2 + 0.075)]}>
                <extrudeGeometry args={[leftTrimModel, extrudeSettings(0.23)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="left-right-trim" position={[-0.03, 0, -(params.p_w / 2 + 0.075)]}>
                <extrudeGeometry args={[rightTrimModel, extrudeSettings(0.225)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            {/* {params.p_f_w === 'Open' && params.p_b_c_b_l_f !== 'Open' && params.add_left_lean && (!params.cB_addStorage_check_left && !params.cB_addStorage_check_right) &&
                <mesh name="left-lean-front-trim" position={[0.03, 0, -(params.p_w / 2 + 0.075)]}>
                    <extrudeGeometry args={[leftLeanFrontTrimModel, extrudeSettings(0.23)]} />
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            }
            {params.p_b_w === 'Open' && params.p_b_c_b_l_b !== 'Open' && params.add_left_lean && (!params.cB_addStorage_check_left && !params.cB_addStorage_check_right) &&
                <mesh name="left-lean-back-trim" position={[-0.03, 0, -(params.p_w / 2 + 0.075)]}>
                    <extrudeGeometry args={[leftLeanBackTrimModel, extrudeSettings(0.225)]} />
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            } */}
            {params.p_l_w !== 'Open' && params.p_l_w !== 'Close' && params.p_j_t && mainTrimModel.jTrim &&(
                <mesh name="left-horizontal-trim" geometry={mainTrimModel.jTrim}>
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            )}
            {params.p_c_p_l == true && params.p_j_t && mainTrimModel.jTrim &&(
                <mesh name="left-horizontal-trim" geometry={mainTrimModel.jTrim}>
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            )}
            {(params.p_u_c && params.p_l_w !== 'Close') && (
                <>
                    <mesh name="back-storage-trim-one" position={[-0.22, 0, -(params.p_w / 2 + 0.0675)]}>
                        <extrudeGeometry args={[backStorageTrimModelOne, extrudeSettings(0.065)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                    <mesh name="back-storage-trim-two" position={[-0.22, 0, -(params.p_w / 2 + 0.01)]}>
                        <extrudeGeometry args={[backStorageTrimModelTwo, extrudeSettings(0.24)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} />
                    </mesh>
                </>
            )}
            {/* {params.add_storage_check_front && params.p_l_w !== 'Close' && (
                <group>
                    <mesh name="front-storage-trim-one" position={[0, 0, -(params.p_w / 2 - 0.05)-0.04]}>
                        <extrudeGeometry args={[frontStorageTrimModelOne, extrudeSettings(-0.04)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                    <mesh name="front-storage-trim-two" position={[0, 0, -(params.p_w / 2 - 0.05)+ 0.07 ]}>    
                        <extrudeGeometry args={[frontStorageTrimModelTwo, extrudeSettings(-0.16)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh> 
                </group>
            )} */}

            {(params.p_w_c_n === true && ((params.p_l_w === "Close") || ((params.p_u_c) && params.p_l_w !== "Close"))) && mainTrimModel.wTrim && (
                <mesh name="wainscotLeftTrim" geometry={mainTrimModel.wTrim}>
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            )}
        </group>
    )
}

export default TrimModel